/**
 * Transforme les agrégateurs depuis le format de la base de données vers un format utilisable par les composants
 * @param {Object} aggregators - Les agrégateurs tels que récupérés depuis Firebase
 * @returns {Array} - Un tableau d'agrégateurs transformés
 */
export const transformAggregators = (aggregators) => {
  if (!aggregators || typeof aggregators !== 'object') {
    console.warn('Aucun agrégateur trouvé ou format invalide', aggregators);
    return [];
  }

  // Convertir l'objet en tableau
  return Object.entries(aggregators).map(([key, agg]) => {
    return {
      id: key,
      name: agg.name || key,
      apiUrl: agg.apiUrl || '',
      description: agg.description || '',
      requiredKeys: agg.requiredKeys || [],
      // Ajouter d'autres propriétés si nécessaire
    };
  });
};